<template lang="html">
</template>

<script>
export default {
  methods: {
    report (category) {
      const trackers = {
        'fb': typeof(fbq) != 'undefined' ? (event, options) => {
          fbq('track', event, options)
        } : false,
        'gtag': typeof(gtag) != 'undefined' ? (event, options) => {
          gtag('event', event, options)
        } : false,
        'ym': typeof(ym) != 'undefined' ? (event, options) => {
          ym(97628213, 'reachGoal', event)
        } : false,
      }

      if (typeof this.events[category] == 'undefined') {
        console.error('Unknown events category:', category)
        return false
      }

      const events = this.events[category]

      for (let platform in trackers) {
        let options = {};

        if (
          !trackers[platform]
          || typeof events[platform] == 'undefined') {
          console.warn('No events in category', category, 'for platform', platform)
          continue
        }

        events[platform].forEach((event) => {
          trackers[platform](event, options)
          console.log('Track', platform, event, options)
        })
      }
    }
  },
  data () {
    return {
      'events': {
        'ticket': {
          'ym': ['ticket'],
        },
        'next_step_clicked': {
          'ym': ['next_step_clicked'],
        },
        'apple_pay_available': {
          'ym': ['apple_pay_available'],
          'gtag': ['apple_pay_available'],
        },
        'can_make_payment_false': {
          'ym': ['can_make_payment_false'],
          'gtag': ['can_make_payment_false'],
        },
        'apple_pay_not_available': {
          'ym': ['apple_pay_not_available'],
          'gtag': ['apple_pay_not_available'],
          'fb': ['SubmitApplication'],
        },
        'apple_id_signup_ok': {
          'ym': ['apple_id_signup_ok']
        },
        'apple_id_signup_error': {
          'ym': ['apple_id_signup_error']
        },
        'recaptcha_client_error': {
          'ym': ['recaptcha_client_error'],
          'gtag': ['recaptcha_client_error']
        },
        'click_try_for_free': {
          'ym': ['click_try_for_free'],
          'fb': ['InitiateCheckout'],
          'gtag': ['begin_checkout'],
        },
        'show_payment_request_apple_pay': {
          'ym': ['show_payment_request_apple_pay'],
          'fb': ['Lead'],
          'gtag': ['show_payment_request_apple_pay'],
        },
        'show_payment_request_error': {
          'ym': ['show_payment_request_error'],
          'fb': ['AddPaymentInfo'],
          'gtag': ['show_payment_request_error'],
        },
        'show_popup_card': {
          'ym': ['show_popup_card'],
          'fb': ['AddToCart'],
          'gtag': ['show_popup_card'],
        },
        'start_trial': {
          'ym': ['redirectToDownload'],
          'fb': ['redirectToDownload'],
          'gtag': ['redirectToDownload'],
        },
        'User_click_start_quiz': {
          'ym': ['User_click_start_quiz'],
        },
        'User_click_quiz': {
          'ym': ['User_click_quiz'],
        },
        'User_click_features': {
          'ym': ['User_click_features'],
        },
        'User_click_testimonials': {
          'ym': ['User_click_testimonials'],
        },
        'User_click_faq': {
          'ym': ['User_click_faq'],
        },
        'User_click_contact': {
          'ym': ['User_click_contact'],
        },
        'User_click_mail': {
          'ym': ['User_click_mail'],
        },
        'User_click_start_quiz1': {
          'ym': ['User_click_start_quiz1'],
        },
        'User_click_start_quiz2': {
          'ym': ['User_click_start_quiz2'],
        },
        'User_click_start_quiz3': {
          'ym': ['User_click_start_quiz3'],
        },
        'User_click_start_quiz4_mobile': {
          'ym': ['User_click_start_quiz4_mobile'],
        },
        'User_click_next_step1': {
          'ym': ['User_click_next_step1'],
        },
        'User_click_next_step2': {
          'ym': ['User_click_next_step2'],
        },
        'User_click_next_step3': {
          'ym': ['User_click_next_step3'],
        },
        'User_click_next_step4': {
          'ym': ['User_click_next_step4'],
        },
        'User_click_next_step5': {
          'ym': ['User_click_next_step5'],
        },
        'User_click_next_step6': {
          'ym': ['User_click_next_step6'],
        },
        'User_click_next_step7': {
          'ym': ['User_click_next_step7'],
        },
        'User_click_next_step8': {
          'ym': ['User_click_next_step8'],
        },
        'User_click_next_step9': {
          'ym': ['User_click_next_step9'],
        },
        'User_click_next_step10': {
          'ym': ['User_click_next_step10'],
        },
        'User_click_next_step11': {
          'ym': ['User_click_next_step11'],
        },
        'User_click_next_step12': {
          'ym': ['User_click_next_step12'],
        },
        'User_click_next_step13': {
          'ym': ['User_click_next_step13'],
        },
        'User_click_next_step14': {
          'ym': ['User_click_next_step14'],
        },
        'User_click_next_step15': {
          'ym': ['User_click_next_step15'],
        },
        'User_click_next_step16': {
          'ym': ['User_click_next_step16'],
        },
        'User_click_next_step17': {
          'ym': ['User_click_next_step17'],
        },
        'User_click_next_step18': {
          'ym': ['User_click_next_step18'],
        },
        'User_click_next_step19': {
          'ym': ['User_click_next_step19'],
        },
        'User_click_next_step20': {
          'ym': ['User_click_next_step20'],
        },
        'User_click_next_step21': {
          'ym': ['User_click_next_step21'],
        },
        'User_click_next_step22': {
          'ym': ['User_click_next_step22'],
        },
        'User_click_next_step23': {
          'ym': ['User_click_next_step23'],
        },
        'User_click_subscription_get_plan1': {
          'ym': ['User_click_subscription_get_plan1'],
        },
        'User_click_subscription_get_plan2': {
          'ym': ['User_click_subscription_get_plan2'],
        },
        'User_click_subscription_get_plan3': {
          'ym': ['User_click_subscription_get_plan3'],
        },
        'User_click_subscription_get_plan4': {
          'ym': ['User_click_subscription_get_plan4'],
        },
        'User_click_subscription_get_plan5': {
          'ym': ['User_click_subscription_get_plan5'],
        },
        'User_click_subscription_get_plan6': {
          'ym': ['User_click_subscription_get_plan6'],
        },
        'User_click_subscription_get_plan_button_fixed': {
          'ym': ['User_click_subscription_get_plan_button_fixed'],
        },
        'User_click_subscription_get_plan_credit_card1': {
          'ym': ['User_click_subscription_get_plan_credit_card1'],
        },
        'User_click_subscription_get_plan_credit_card2': {
          'ym': ['User_click_subscription_get_plan_credit_card2'],
        },
      },
    }
  },
  computed: {
    session() {
      return this.$parent.$refs.session
    }
  }
}
</script>
